package ru.villawonka.app

data object AppConfig {
    val apiUrl: String = when {
        BuildConfig.isRelease -> "https://api.villawonka.io"
        else -> "https://staging.api.villawonka.io"
    }

    val miniAppUrl: String = when {
        BuildConfig.isRelease -> "https://t.me/VillaWonkaBot"
        else -> "https://t.me/bdAn1hGLlz_bot"
    }

    const val APP_VERSION: String = "1.0.0"
    const val TELEGRAM_CHANNEL_LINK = "https://t.me/villawonka"
    const val PRIVACY_POLICY_LINK = "https://villawonka.io/privacy-policy"
    const val TERMS_OF_USE_LINK = "https://villawonka.io/terms"
    const val SUPPORT_LINK = "https://t.me/aelisov"
}